import { render, staticRenderFns } from "./grossing-touch-sample-pending-card.vue?vue&type=template&id=07cc6c54&scoped=true&"
import script from "./grossing-touch-sample-pending-card.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-sample-pending-card.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-sample-pending-card.scss?vue&type=style&index=0&id=07cc6c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc6c54",
  null
  
)

export default component.exports